import React from 'react';
import { i18n } from 'config/locales';
import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_TECHNOLOGY_MANIPULATING } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import { isPVQForm } from 'helpers/form';
import ManipulatingItem from './ManipulatingItem';

const sectionConfig = {
  key: LEGAL_TECHNOLOGY_MANIPULATING.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_TECHNOLOGY_MANIPULATING.name,
  storeKey: LEGAL_TECHNOLOGY_MANIPULATING.storeKey,
};

export class Manipulating extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateBranch = this.updateBranch.bind(this);
    this.updateList = this.updateList.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasManipulating: this.props.HasManipulating,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasManipulating: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const dates = DateSummary(o.Date);

    return Summary({
      type: i18n.t('legal.technology.manipulating.collection.item'),
      index,
      left: '',
      right: dates,
      placeholder: i18n.t('legal.technology.manipulating.collection.unknown'),
    });
  };

  render() {
    const { errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);
    const isPVQ = isPVQForm(this.props.formType);
    return isPVQ ? (
      <div
        className="section-content legal-technology-manipulating"
        data-section={LEGAL.key}
        data-subsection={LEGAL_TECHNOLOGY_MANIPULATING.key}
      >
        <h1 className="section-header">{i18n.t('legal.subsection.technology.manipulating')}</h1>
        <Branch
          name="has_manipulating"
          label={i18n.t('legal.pvq.technology.manipulating.heading.title')}
          labelSize="h4"
          className="legal-pvq-technology-manipulating-has-manipulating"
          {...this.props.HasManipulating}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasManipulating"
        />

        <Show when={this.props.HasManipulating.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary} // eslint-disable-line @typescript-eslint/unbound-method
            onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('legal.technology.manipulating.collection.description')}
            appendTitle={i18n.t('legal.pvq.technology.manipulating.collection.appendTitle')}
            appendLabel={i18n.t('legal.technology.manipulating.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <ManipulatingItem
              name="Item"
              bind
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
              formTypes={this.props.formType}
              formType={this.props.formType}
            />
          </Accordion>
        </Show>
      </div>
    )
      : (
        <div
          className="section-content legal-technology-manipulating"
          data-section={LEGAL.key}
          data-subsection={LEGAL_TECHNOLOGY_MANIPULATING.key}
        >
          <h1 className="section-header">{i18n.t('legal.subsection.technology.manipulating')}</h1>
          <Branch
            name="has_manipulating"
            label={i18n.t('legal.technology.manipulating.heading.title')}
            labelSize="h4"
            className="legal-technology-manipulating-has-manipulating"
            {...this.props.HasManipulating}
            warning
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
            onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
            scrollIntoView={this.props.scrollIntoView}
            attribute="HasManipulating"
          />

          <Show when={this.props.HasManipulating.value === 'Yes'}>
            <Accordion
              defaultState={this.props.defaultState}
              {...this.props.List}
              scrollToBottom={this.props.scrollToBottom}
              summary={this.summary} // eslint-disable-line @typescript-eslint/unbound-method
              onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
              onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
              errors={accordionErrors}
              description={i18n.t('legal.technology.manipulating.collection.description')}
              appendTitle={i18n.t('legal.technology.manipulating.collection.appendTitle')}
              appendLabel={i18n.t('legal.technology.manipulating.collection.appendLabel')}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              attribute="List"
            >
              <ManipulatingItem
                name="Item"
                bind
                addressBooks={this.props.addressBooks}
                dispatch={this.props.dispatch}
                required={this.props.required}
                scrollIntoView={this.props.scrollIntoView}
                attribute="List"
              />
            </Accordion>
          </Show>
        </div>
      );
  }
}

Manipulating.defaultProps = {
  name: 'manipulating',
  HasManipulating: {},
  List: EmptyListInstance,
  defaultState: true,
  onUpdate: () => {},
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'technology/manipulating',
  addressBooks: {},
  dispatch: () => {},
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(Manipulating, sectionConfig);
